export default {
	namespaced:true,
	state: {
    abbreviation: '',
	},
	getters: {
    abbreviation: s => s.abbreviation,
	},
	actions: {
	},


	mutations: {
	  //存储 教材简称，教材章节中要用到
    setAbbreviation(state,data){
      state.abbreviation = data;
		},
	}
}
